module.exports = __webpack_public_path__ + "img/hoshino_mo.c665154f.jpg";